import { createTheme as e } from "flowbite-react";
const t = e({
  textInput: {
    field: {
      icon: {
        base: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 z-10"
      },
      rightIcon: {
        base: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 z-10"
      },
      input: {
        colors: {
          failure: "bg-white/10 dark:bg-white/10 backdrop-blur-[15px] border-red-500 dark:border-red-400 text-red-900 placeholder-red-700/50 dark:placeholder-red-700/50 focus:border-red-500 dark:focus:border-red-500 focus:ring-red-500 dark:focus:ring-red-500",
          gray: "bg-white/10 dark:bg-white/10 backdrop-blur-[15px] border-transparent dark:border-transparent text-white dark:text-white placeholder-white/50 dark:placeholder-white/50 focus:border-transparent dark:focus:border-transparent dark:focus:ring-0"
        }
      }
    }
  }
}).textInput;
export {
  t as theme
};
